import React, { Component, Fragment } from "react";
import { TableBody, Table, TableRow, TableCell, TableHead } from "@material-ui/core";
import { HedgeEscrowLedgerColumns } from './HedgeEscrowLedgerColumns';
import { Form, FieldArray, Formik } from "formik";

class HedgeEscrowLedgerTable extends Component {
  constructor(props) {
    super(props);
    this.formik = React.createRef();
  }

  getTable = ({ values }) => (
    <Form>
      <FieldArray name="hedgeEscrows">
        <Table className="loansList_Table tableTextBlack">
          <TableHead>
            <TableRow>{this.getHeaders()}</TableRow>
          </TableHead>
          <TableBody>{this.getRows(values)}</TableBody>
        </Table>
      </FieldArray>
    </Form >
  );

  getCapCostInflator = () => {    
    return (this.props.hedge && this.props.hedge.pricingInflator) ? `(${this.props.hedge.pricingInflator}x)` :  "";
  };

  getHeaders = () => {
    const columns = HedgeEscrowLedgerColumns(this.getCapCostInflator);

    return (
      Object.keys(columns).map((key, index) => (
        <TableCell key={index} width={60} style={{ color: 'black !important', ...columns[key].style }}>{columns[key].label}</TableCell>
      ))
    );
  }

  isEditableRow = (data) => data && (data.isRecalcInterval || data.isCapPurchaseDue);

  getRows = (values) => {
    const { onSave } = this.props;

    if (values && !values.hedgeEscrows.length) return (
      <TableRow>
        <TableCell colSpan={6} style={{ textAlign: 'center' }}>There are no Hedge Escrows for this hedge</TableCell>
      </TableRow>
    );

    const columns = HedgeEscrowLedgerColumns(this.getCapCostInflator);
    const backgroundColor = (data) => this.isEditableRow(data) ? '#ccebf9' : 'inherit';

    return values.hedgeEscrows.map((data, index) => (
      <TableRow key={index} hover style={{ backgroundColor: backgroundColor(data) }}>
        {columns.date.Cell({ data })}
        {columns.capCostMarket.Cell({ data, isEditable: this.isEditableRow, onSave, index })}
        {columns.capCostInflated.Cell({ data })}
        {columns.monthlyEscrow.Cell({ data })}
        {columns.disbursement.Cell({ data })}
        {columns.escrowBalance.Cell({ data })}
      </TableRow>
    ))
  }

  render() {
    const { hedgeEscrows } = this.props;

    return (
      <Fragment>
        <Formik
          enableReinitialize
          ref={this.formik}
          render={this.getTable}
          initialValues={{ hedgeEscrows }}
        />
      </Fragment>
    );
  }
}

export default HedgeEscrowLedgerTable;